import {Injectable} from '@nestjs/common';
import { Repository } from 'typeorm';
import { Qualifications } from './qualifications.entity';
import { QualificationDTO } from './dto/qualifications.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { QualificationAdapter } from './dto/qualifications.adapter';
import { QualificationsResponse, AllQualificationsResponse } from '@gtpl/shared-models/masters';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { QualificationsRequest } from './dto/qualifications.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class QualificationService{
    constructor(
      private logService:LogsService,

        @InjectRepository(Qualifications) 
        private qualificationsRepository: Repository<Qualifications>,
        private qualificationsAdapter: QualificationAdapter,
    ){}

    async getQualificationDetailsWithoutRelations(qualificationName: string): Promise<Qualifications> {
        // tslint:disable-next-line: typedef
        const qualificationResponse = await this.qualificationsRepository.findOne({
          where: {qualificationName:qualificationName},
        });
        if (qualificationResponse) {
          return qualificationResponse;
        } else {
          return null;
        }
      }

      async createQualification(qualificationDto: QualificationDTO, isUpdate: boolean): Promise<QualificationsResponse> {
        
        try {
             if (!isUpdate) {
            const qualificationsEntity = await this.getQualificationDetailsWithoutRelations(qualificationDto.qualificationName);
            if (qualificationsEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'Qualification already exists');
            }
          }
          else{
            const qualificationsEntity = await this.getQualificationDetailsWithoutRelations(qualificationDto.qualificationName);
            if(qualificationsEntity){
                if(qualificationsEntity.qualificationId!=qualificationDto.qualificationId) {
                    throw new ErrorResponse(11104, 'qualification already exists');      
                }
            }
          }
          const convertedEntity: Qualifications = this.qualificationsAdapter.convertDtoToEntity(qualificationDto,isUpdate);
          const savedEntity: Qualifications = await this.qualificationsRepository.save(
            convertedEntity
          );
          const savedDto: QualificationDTO = this.qualificationsAdapter.convertEntityToDto(convertedEntity);
                     if (savedDto) {
            // generating resposnse
        const response = new QualificationsResponse(true,1,isUpdate? 'Qualification Updated Successfully': 'Qualification Created Successfully');
        const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'Qualifications', savedDto.qualificationId, true, '',savedDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
        return response;

          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'Qualification saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  

      async getAllQualifications(): Promise<AllQualificationsResponse> {
          try {
              const qDtos: QualificationDTO[] = [];
              const qEntities: Qualifications[] = await this.qualificationsRepository.find({order: {qualificationName: 'ASC'}});
              if(qEntities){
                  qEntities.forEach(qEntity => {
                      const convertedDto: QualificationDTO = this.qualificationsAdapter.convertEntityToDto(
                        qEntity
                      );
                      qDtos.push(convertedDto);
                  });
                  const response = new AllQualificationsResponse(true, 1, 'Qualifications retrieved successfully', qDtos);
                  const newLogDto = new LogsDto(1,'view', 'Qualifications', 0, true, '','')
                  let res = await this.logService.createLog(newLogDto);
                  console.log(res);
                  return response;                  
              } else {
                  throw new ErrorResponse(99998, 'Data Not Found');
              }
          } catch(err) {
            throw err;
        }
      }
      async getAllActiveQualifications(): Promise<AllQualificationsResponse> {
        // const page: number = 1;
        try {
            const qDtos: QualificationDTO[] = [];
            //retrieves all companies
            const qEntities: Qualifications[] = await this.qualificationsRepository.find({ order: { qualificationName: 'ASC' },
           });
         console.log(qEntities)
            if (qEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                qEntities.forEach(Entity => {
                    const convertedDto: QualificationDTO = this.qualificationsAdapter.convertEntityToDto(
                      Entity
                    );
                    qDtos.push(convertedDto);
                });
                const response = new AllQualificationsResponse(true, 11108, "Qualifications retrieved successfully", qDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }

    async activateOrDeactivateQualification(qReq: QualificationsRequest): Promise<QualificationsResponse> {
        try {                    
            const qExists = await this.getQualificationById(qReq.qualificationId);
            if (qExists) {
                if (qReq.versionFlag !== qExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current qualification information.Refresh and try again');
                } else {
                    
                        const qStatus =  await this.qualificationsRepository.update(
                            { qualificationId: qReq.qualificationId },
                            { isActive: qReq.isActive,updatedUser: qReq.updatedUser });
                       
                        if (qExists.isActive) {
                            if (qStatus.affected) {
                                const qualificationResponse: QualificationsResponse = new QualificationsResponse(true, 10115, 'Qualification is de-activated successfully');
                                return qualificationResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Qualification is already deactivated');
                            }
                        } else {
                            if (qStatus.affected) {
                                const qualificationResponse: QualificationsResponse = new QualificationsResponse(true, 10114, 'Qualification is activated successfully');
                                return qualificationResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Qualification is already  activated');
                            }
                        }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getQualificationById(qualificationId: number): Promise<Qualifications> {
            const Response = await this.qualificationsRepository.findOne({
            where: {qualificationId: qualificationId},
            });
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}